import { createTheme, Theme } from '@mui/material/styles';

export const primaryColor = '#F19001';
export const secondaryColor = '#747A85';

// Trying to group all theme configs in this one
export const globalTheme = createTheme({
    palette: {
        primary: {
            main: primaryColor,
            contrastText: '#FFF',
        },
        secondary: {
            main: secondaryColor,
        },
        iconOnPrimary: {
            main: '#FFF',
        },
        tonalOffset: 0.05,
    },
    components: {
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: primaryColor,
                    color: '#fff',
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    border: '0px !important',
                    borderBottom: '0px !important',
                    color: 'rgb(102, 110, 114)',
                    fontSize: '16px',
                },
                toolbarContainer: {
                    marginLeft: '10px', // align toolbox with first column
                },
                columnHeader: {
                    marginTop: '10px',
                    marginBottom: '10px',
                },
                columnHeaderCheckbox: {
                    // marginLeft: '15px', // align header checkbox with checkboxes in rows
                },
                columnHeadersTitle: {
                    fontWeight: 'bold',
                },
                columnHeaderTitleContainer: {
                    padding: '0px', // align text of headers with text of rows
                },
                columnSeparator: {
                    visibility: 'hidden',
                },
                row: {
                    backgroundColor: '#F9F9F9 !important', // prevent changing color when selected
                    // paddingLeft: '5px',
                    // paddingRight: '5px',
                    marginTop: '10px',
                    borderRadius: '10px',
                },
                cell: {
                    borderBottom: '0px !important',
                },
            },
        },
    },
});

/**
 * Theme for buttons and chips, setting brand color and letting MUI define the color changes upon interactions
 * @type {Theme}
 */
export const buttonsTheme = createTheme({
    palette: {
        primary: {
            main: primaryColor,
            contrastText: '#FFF',
        },
        secondary: {
            main: secondaryColor,
        },
        iconOnPrimary: {
            main: '#FFF',
        },
        tonalOffset: 0.05,
    },
});

/**
 * Theme for the datagrid in masschange
 * @type {Theme}
 */
export const datagridTheme = createTheme({
    palette: {
        primary: {
            main: primaryColor,
        },
    },
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    border: '0px !important',
                    borderBottom: '0px !important',
                    color: 'rgb(102, 110, 114)',
                    fontSize: '16px',
                },
                toolbarContainer: {
                    marginLeft: '10px', // align toolbox with first column
                },
                columnHeader: {
                    marginTop: '10px',
                    marginBottom: '10px',
                },
                columnHeaderCheckbox: {
                    // marginLeft: '15px', // align header checkbox with checkboxes in rows
                },
                columnHeadersTitle: {
                    fontWeight: 'bold',
                },
                columnHeaderTitleContainer: {
                    padding: '0px', // align text of headers with text of rows
                },
                columnSeparator: {
                    visibility: 'hidden',
                },
                row: {
                    backgroundColor: '#F9F9F9 !important', // prevent changing color when selected
                    // paddingLeft: '5px',
                    // paddingRight: '5px',
                    marginTop: '10px',
                    borderRadius: '10px',
                },
                cell: {
                    borderBottom: '0px !important',
                },
            },
        },
    },
});
